// loader
const trayaProcessingAnimation = document.getElementById('traya-processing-animation');

// Get URL parameter value
function getUrlParameter(param) {
  const queryString = window.location.search.substring(1);
  const urlParams = queryString.split('&');

  for (let i = 0; i < urlParams.length; i++) {
    const pair = urlParams[i].split('=');
    if (pair[0] === param) {
      return pair[1] === undefined ? true : decodeURIComponent(pair[1]);
    }
  }
  return null;
}

// Initial values & global variables
let id = getUrlParameter('id');
let cohort = getUrlParameter('cohort');
let f_name = "", C_number = "", C_email = "";
let user__gender = "", user_gender = "", rid = "", caseId = "";
let selectedStage = 'Stage-1';
let variantsID = 0;
let recommended_products = [];
let prices = 0;
const doc__fee = 100000;
const diet__plan = 50000;
const hair__coach_fee = 50000;
let month1_total, month1DiscountPrice, month3DiscountPrice, month6DiscountPrice;
let discount_pricetext = 0;
let successfulFetchCount = 0;
let totalProducts = 0;
if (id) {
  localStorage.setItem('user-gender', 'male');
  localStorage.setItem('rid', id);
}

id = localStorage.getItem('rid');
if (id === undefined) {
  id = getCookie('syntheticId');
}

(function () {
  if (!id) {
    // Redirect if ID is not found and path is result page
    if (window.location.pathname === '/pages/result4-details') {
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href = 'https://form.traya.health/questions?cohort=1&source=ResultPage';
    }    
  } else {
    setotherCookie('syntheticId', id, 30, '.traya.health');
  }

  // API URLs and Tokens
  const baseUrls = {
    DEV: 'https://revamp-api.dev.hav-g.in/',
    PROD: 'https://api.hav-g.in/'
  };
  const tokens = {
    DEV: {
      Authorization: "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: {
      Authorization: "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };
  const token = tokens.PROD;
  const baseUrl = baseUrls.PROD;
  let liveendpoint = baseUrl + 'dgReport/male?id=';
  if (cohort == 2) {
    liveendpoint = baseUrl + 'dgReport/male?id=';
  }
  liveendpoint = 'https://api.hav-g.in/dgReport/male?id=';
  getMaleResult(liveendpoint, id, token);
})();

async function getMaleResult(livepoint, id, token) {
  document.body.style.overflow = 'hidden';
  try {
    const response = await fetch(`${livepoint}${id}`, {
      headers: token
    });
    const data = await response.json();
    caseId = String(data?.User_Analysis?.case_id).trim();
    tagClarityCaseId(caseId);
    // Call downstream functions
    rootCause(data?.root_causes);
    recommendedProducts(data);
    getProductByHandle(data);
    displayProduct(data);
    sectionMonthsExpectetion(data);
    sectionRealStories(data);
    resultMonthKit(data);
    showKitDetailsDrawer(data)
    trackMetaEvent(data.User_Analysis, "Viewed Content");
  } catch (error) {
    console.error('Error: ', error);
    document.body.style.overflow = 'unset';
  };
}


// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

function fireEvent(eventName, caseID) {
  const attributes = {
    platform: "web_shopify",
    domain: "traya.health",
    syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
  };

  let pageURL = `https://traya.health/pages/result-details?id=${id}`;
  const baseAPI = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  const baseTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };

  // ✅ Return the fetch so caller can chain `.finally()`
  return fetch(`${baseAPI.PROD}eventMoengageWeb`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...baseTokens.PROD
    },
    body: JSON.stringify({
      eventName: eventName,
      eventAttributes: {
        generalAttributes: {
          platform: "web_shopify",
          domain: "traya.health",
          pageUrl: pageURL,
          syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      caseId: caseID
    })
  });
}

const chatButtonElement = document.querySelector('.chat-content .chat-btn');
if(chatButtonElement){
  chatButtonElement.addEventListener("click", (e) => {
    e.preventDefault(); // Stop default navigation
    fireEvent("chat_now_rp2", caseId)
      .finally(() => {
        window.location.href = chatButtonElement.href; 
      });
  });
}

function displayProduct(data) {
  var r = Object.assign(data.User_Analysis, data.Recommendations);
  f_name = r.first_name;
  C_number = r.phone;
  C_email = r.email;
  user__gender = r.gender;
  if(user__gender == 'M') {
    user_gender = 'Male';
  }
  $('[data-user-name]').text(data.User_Analysis.first_name);
  $('#name1').text(data.User_Analysis.first_name);
  $('#name3').text(data.User_Analysis.first_name);
  $('#typeOfLoss').text(data.Recommendations.Type_of_hair_loss);
  $('#stage').text(data.User_Analysis.stage);
  $('#typeOfLoss3').text(data.Recommendations.Type_of_hair_loss);
  $('#stage3').text(data.User_Analysis.stage);
  
  let stageDescription = data.stageWiseDescription.english;
  let stageDescriptionMain = document.querySelector('#stageDescription');
  if(stageDescriptionMain) { 
    stageDescriptionMain.innerHTML = `${stageDescription}`; 
  }
  $('#stageDescription').text(stageDescription[data.User_Analysis.stage]);
  selectedStage = data.User_Analysis.stage;

  $('.' + selectedStage).addClass('selectedStage');

  if (selectedStage === 'Stage-1') {
  } else if (selectedStage === 'Stage-1') {
  } else if (selectedStage === 'Stage-2') {
    $('.Stage-1').addClass('checkStage');
  } else if (selectedStage === 'Stage-3') {
    $('.Stage-1').addClass('checkStage');
  } else if (selectedStage === 'Stage-4') {
    $('.Stage-2').addClass('checkStage');

  } else if (selectedStage === 'Stage-5') {

    $('.Stage-3').addClass('checkStage');
  } else if (selectedStage === 'Stage-6') {

    $('.Stage-5').addClass('checkStage');
  } else if (selectedStage === 'Coin Size Patch') {
    $('.Stage-7').addClass('selectedStage');
    $('.Stage-1').addClass('checkStage hide-text');

  } else if (selectedStage === 'Heavy Hair Fall Across The Head') {
    $('.Stage-8').addClass('selectedStage');
    $('.Stage-1').addClass('checkStage hide-text');
  }

   // Recommended Products End
  if (r.stage == "Stage-1") {
    document.querySelector('#stage').innerHTML = 'Stage 1 Of Male Pattern Hair Fall';
  }else if (r.stage == "Stage-2") {
    document.querySelector('#stage').innerHTML = 'Stage 2 Of Male Pattern Hair Fall';
  }else if(r.stage == "Stage-3"){
    document.querySelector('#stage').innerHTML = 'Stage 3 Of Male Pattern Hair Fall';
  }else if(r.stage == "Stage-4"){
    document.querySelector('#stage').innerHTML = 'Stage 4 Of Male Pattern Hair Fall';
  }else if(r.stage == "Stage-5"){
    document.querySelector('#stage').innerHTML = 'Stage 5 Of Male Pattern Hair Fall';
  }else if(r.stage == "Heavy Hair Fall Across The Head"){
    document.querySelector('#stage').text = 'Male Pattern Hair Fall';
  }
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
}

function rootCause(response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="auto" height="auto"/>
        </div>
         <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" width="auto" height="auto"/>
        </div>
        <p class="mt-2">${item?.title}</p>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
 const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

function getProductByHandle(response) {
  let femaleResultBuyBtn = document.querySelectorAll('#add-to-cart-result-page');
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let sticky_slash_price_element = document.getElementById('sticky-slash-price');
  const finalCartPrice = Math.round(response.cart_price);
  
  if (resultTotalPrice.length !== 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${finalCartPrice}`;
    });
  }
  
  if (sticky_slash_price_element) {
    sticky_slash_price_element.innerHTML = `₹ ${finalCartPrice + 500}`;
  }

  if(femaleResultBuyBtn.length != 0) {
    femaleResultBuyBtn.forEach((buyBtn) => {
      buyBtn.setAttribute('data-price', finalCartPrice);
    })
  }
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

function redirectWithCartAttributes(variantsIDs, resp) {
  // Prepare attribute data
  const formData = {
    attributes: {
      first_name: resp.first_name,
      phone: resp.phone,
      email: resp.email,
      caseid: resp.case_id,
      syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
    }
  };

  // Update cart attributes first
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(res => res.json())
  .then(data => {
    console.log("Cart attributes updated:", data);

    // Build your existing cart permalink
    const cartItems = variantsIDs.map(item => `${item.id}:${item.quantity}`).join(',');
    const cartPermalink = `https://traya.health/cart/${cartItems}`;

    // Redirect
    // window.location.href = cartPermalink;
    document.querySelector('#add-to-cart-result-page')?.setAttribute('href', cartPermalink);
  })
  .catch(err => {
    console.error("Error updating cart attributes:", err);
    // Fallback: go directly to cart if attributes fail
    const cartItems = variantsIDs.map(item => `${item.id}:${item.quantity}`).join(',');
    const cartPermalink  = `https://traya.health/cart/${cartItems}`;

    document.querySelector('#add-to-cart-result-page')?.setAttribute('href', cartPermalink);
  });
}

// product kit section
function recommendedProducts(response){
  let productsData = response.product_Ids
  let productCardContainer = document.querySelector('.recommended-product-details-container');
  const variantsIDs = [];
  productsData.forEach((product, index) => {
    const tagsArray = product.tag.tagKeyArray;
    let tagsHTML = '';
    if (tagsArray.length > 1) {
      tagsHTML = tagsArray
        .map(tag => `<p class="tag-title">For ${tag}</p>`)
        .join('');
    } else {
      tagsHTML = `<p class="tag-title">For ${product.tag.title}</p>`;
    }
    const vectorURL = index % 2 === 0 
    ? `<svg xmlns="http://www.w3.org/2000/svg" width="49" height="46" viewBox="0 0 49 46" fill="none"><path d="M0.0280962 44.9011C4.64583 44.0806 8.81689 40.7569 12.8674 37.718C16.8453 34.6566 20.7261 31.2426 24.4211 27.5558C31.3682 20.582 37.3706 12.347 43.3323 3.88448C41.0371 5.42738 38.839 7.32292 36.8094 8.62606C36.0443 9.14036 34.5829 7.28871 33.9949 7.64317C37.5706 5.20893 41.8856 0.962743 45.8993 0.599164C46.1331 0.564392 48.6573 1.45699 48.6413 1.55948C46.8532 8.63347 44.6136 15.6745 41.5265 21.8071C41.4219 21.9895 39.5509 21.3001 39.5829 21.0951L39.5569 19.7975C39.5569 19.7975 39.7747 19.8652 39.9924 19.9329C41.253 16.2413 42.5136 12.5496 43.6451 8.71031C38.521 16.6811 32.3476 23.5732 26.1729 29.4978C19.1125 36.2215 10.5306 44.4064 1.82654 45.568C1.28653 45.6149 0.422953 44.809 0.0280962 44.9011Z" fill="#DFDDDD"/></svg>`
    : `<svg xmlns="http://www.w3.org/2000/svg" width="57" height="35" viewBox="0 0 57 35" fill="none"><path d="M56.2868 34.3656C54.12 30.206 49.699 27.2229 45.5859 24.2693C41.473 21.3917 37.0528 18.7126 32.4281 16.2924C23.6927 11.7547 14.0374 8.49632 4.17709 5.34488C6.33697 7.07222 8.80414 8.60114 10.6557 10.1469C11.3756 10.7227 10.0471 12.6719 10.5615 13.1266C7.16747 10.4448 1.82326 7.60082 0.273442 3.88051C0.170223 3.66795 0.265264 0.992257 0.367837 0.976788C7.65256 0.562592 15.0411 0.588966 21.8171 1.69624C22.0224 1.7413 21.9255 3.73294 21.7203 3.76388L20.4901 4.17752C20.4901 4.17752 20.4894 3.9495 20.4888 3.72148C16.589 3.62522 12.6893 3.52896 8.68735 3.60018C17.8275 6.09983 26.253 9.92386 33.7558 14.0391C42.2865 18.7598 52.6672 24.4941 56.384 32.4499C56.5906 32.9511 56.0806 34.0165 56.2868 34.3656Z" fill="#DFDDDD"/></svg>`;

     const vectorDesktopURL = index % 2 === 0 
    ? `<svg xmlns="http://www.w3.org/2000/svg" width="49" height="46" viewBox="0 0 49 46" fill="none"><path d="M0.0280962 44.9011C4.64583 44.0806 8.81689 40.7569 12.8674 37.718C16.8453 34.6566 20.7261 31.2426 24.4211 27.5558C31.3682 20.582 37.3706 12.347 43.3323 3.88448C41.0371 5.42738 38.839 7.32292 36.8094 8.62606C36.0443 9.14036 34.5829 7.28871 33.9949 7.64317C37.5706 5.20893 41.8856 0.962743 45.8993 0.599164C46.1331 0.564392 48.6573 1.45699 48.6413 1.55948C46.8532 8.63347 44.6136 15.6745 41.5265 21.8071C41.4219 21.9895 39.5509 21.3001 39.5829 21.0951L39.5569 19.7975C39.5569 19.7975 39.7747 19.8652 39.9924 19.9329C41.253 16.2413 42.5136 12.5496 43.6451 8.71031C38.521 16.6811 32.3476 23.5732 26.1729 29.4978C19.1125 36.2215 10.5306 44.4064 1.82654 45.568C1.28653 45.6149 0.422953 44.809 0.0280962 44.9011Z" fill="#DFDDDD"/></svg>`
    : `<svg xmlns="http://www.w3.org/2000/svg" width="57" height="34" viewBox="0 0 57 34" fill="none"><path d="M0.150717 33.8265C2.31749 29.667 6.73853 26.6838 10.8516 23.7302C14.9645 20.8527 19.3847 18.1735 24.0094 15.7533C32.7448 11.2156 42.4001 7.95726 52.2604 4.80582C50.1005 6.53316 47.6334 8.06208 45.7818 9.60781C45.0619 10.1836 46.3904 12.1328 45.876 12.5875C49.27 9.90572 54.6142 7.06176 56.1641 3.34144C56.2673 3.12889 56.1722 0.453194 56.0697 0.437726C48.7849 0.0235293 41.3964 0.049903 34.6204 1.15717C34.4151 1.20224 34.512 3.19388 34.7172 3.22482L35.9474 3.63846C35.9474 3.63846 35.9481 3.41044 35.9487 3.18242C39.8485 3.08616 43.7482 2.9899 47.7502 3.06112C38.61 5.56077 30.1845 9.3848 22.6817 13.5001C14.151 18.2207 3.77033 23.955 0.0535297 31.9109C-0.153127 32.412 0.356943 33.4774 0.150717 33.8265Z" fill="#DFDDDD"/></svg>`;

    const productDiv = document.createElement('div');
    productDiv.classList.add('recommended-product-details', 'kit-card-container');
    
    const cardClass = index % 2 === 0 ? 'even-product-card' : 'odd-product-card';
    productDiv.classList.add(cardClass);
    productDiv.dataset.productId = product.product_id;
    productDiv.innerHTML = `
          <div class="recommended-product--image">
            <img src="${product.image_url.singleImage}" width="140" height="140" />
            <span class="d-none d-md-block">${vectorDesktopURL}</span>
            <span class="d-md-none">${vectorURL}</span>
          </div>
          <div class="recommended-product--details">
             ${product.type === 'Ayurveda' || product.type === 'ayurveda' 
              ? `<p class="recommended-product--type d-none">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11" fill="none">
                  <path d="M0.715078 0.28945C0.729387 0.239874 0.754075 0.193402 0.787722 0.152694C0.821368 0.111986 0.863318 0.0778394 0.911175 0.052205C0.959031 0.0265706 1.01185 0.00994845 1.06663 0.00329464C1.1214 -0.00335917 1.17705 8.8371e-05 1.23039 0.0134293L1.2377 0.0152771C1.33295 0.0441615 2.20399 0.550027 3.46698 1.10763C5.0769 1.81816 7.21807 2.73025 8.05735 4.11037C9.326 6.19638 8.90909 7.87043 6.82178 9.09207L7.67835 10.5006C7.70266 10.5384 7.71858 10.5803 7.72518 10.624C7.73178 10.6676 7.72893 10.7119 7.71678 10.7545C7.70463 10.7971 7.68344 10.837 7.65446 10.8718C7.62547 10.9066 7.58928 10.9357 7.54801 10.9574C7.50673 10.979 7.46122 10.9928 7.41414 10.9978C7.36707 11.0029 7.31937 10.9991 7.27388 10.9868C7.22839 10.9744 7.18601 10.9538 7.14925 10.926C7.11249 10.8982 7.08208 10.8639 7.05981 10.825L6.20308 9.41644C4.00007 10.4479 2.24155 9.91628 0.972901 7.83027C-0.525972 5.368 0.663382 0.495811 0.715078 0.28945ZM1.9548 7.45864C3.01716 9.20513 3.9886 9.60473 5.8023 8.75874L5.00574 7.44891L3.53114 7.25397C3.48429 7.2486 3.43906 7.2346 3.39809 7.2128C3.35713 7.191 3.32124 7.16184 3.29254 7.12701C3.26383 7.09219 3.24289 7.0524 3.23092 7.00997C3.21895 6.96754 3.21619 6.92331 3.22282 6.87988C3.22944 6.83644 3.24532 6.79468 3.26951 6.75701C3.2937 6.71934 3.32572 6.68652 3.36371 6.66048C3.4017 6.63443 3.44488 6.61569 3.49075 6.60533C3.53663 6.59497 3.58426 6.59321 3.63088 6.60014L4.56424 6.72371L3.70235 5.30667C3.6598 5.2307 3.65068 5.14233 3.67692 5.06022C3.70315 4.97811 3.76269 4.90868 3.84297 4.86659C3.92325 4.82451 4.01799 4.81305 4.10719 4.83464C4.19639 4.85622 4.27308 4.90918 4.32106 4.98231L6.42068 8.43452C7.03838 8.07185 7.70311 7.85205 7.96891 7.39268C8.44083 6.57635 8.12916 5.4168 7.44945 4.29912C6.67932 3.03253 4.55244 2.44218 3.00802 1.7814C2.33098 1.49147 1.79456 1.00708 1.41589 0.876865C1.30436 1.42072 0.761958 2.57502 0.696299 3.69394C0.615346 5.06556 1.34409 6.4551 1.95431 7.45864H1.9548Z" fill="#404040"/>
                </svg>
              <span>${product.type}</span>
              </p>` 
              : ``}
            <div class="recommended-product-usage">
              ${tagsHTML}
            </div>
            <p class="recommended-product--oneliner">
              ${product.oneLiner}
            </p>
          </div>`
    
    productCardContainer.appendChild(productDiv);
    
    if (getCookie("GuestForm_id")) {
      variantsIDs.push({
        id: product.product_id,
        quantity: 1,
        properties: {
          '_result_id': id
        }
      });
    } else {
      variantsIDs.push({
        id: product.product_id,
        quantity: 1
      });
    }
    
    redirectWithCartAttributes(variantsIDs, response);
  });
  let maleCartParamButton = document.querySelectorAll('#add-to-cart-result-page');
  maleCartParamButton.forEach((cartButton) => {
    cartButton.addEventListener('click', ()=>{
      fireEvent("buy_now_rp_2", String(response?.User_Analysis?.case_id).trim());
      trackMetaEvent(response.User_Analysis, "Expand Benefits");
      window.umami.track('buy_now_click', {
        syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
        fingerprintId: window.__deviceId
      });
    })
  })
}
  // new json data for the title and descritpion
  const updatedDataFromAPI = [
    {
      "variantId": "46528923304114",
      "name": "For Advanced Dandruff",
      "one_liner": "Advanced Anti-Dandruff Solution for stubbon dandruff"
    },
    {
      "variantId": "47329496826034",
      "name": "For Dandruff",
      "one_liner": "Anti-Dandruff Shampoo with proven actives"
    },
    {
      "variantId": "41645770309810",
      "name": "For Hair Regrowth",
      "one_liner": "Recap Serum with Hair Growth Actives"
    },
    {
      "variantId": "47329517568178",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "47302891929778",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "47301151064242",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "44650256728242",
      "name": "For Hair Texture",
      "one_liner": "Defence Conditioner for hydrated hair (SLS Free)"
    },
    {
      "variantId": "47276533121202",
      "name": "For Sleep",
      "one_liner": "Nasal Ghrit for restful sleep"
    },
    {
      "variantId": "46528902496434",
      "name": "For Digestion",
      "one_liner": "Gut Shuddi for constipation relief"
    },
    {
      "variantId": "46528906821810",
      "name": "For Hair Nutrition",
      "one_liner": "Hair Ras for hair nourishment"
    },
    {
      "variantId": "47303072710834",
      "name": "For Hairfall Control",
      "one_liner": "Hair Vitamin with natural hormone-blockers"
    },
    {
      "variantId": "47276523749554",
      "name": "For Metabolism",
      "one_liner": "Health Tatva for improved energy"
    },
    {
      "variantId": "46531537273010",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for scalp health"
    },
    {
      "variantId": "46530268987570",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for stress"
    },
    {
      "variantId": "46531521872050",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for hair growth"
    },
    {
      "variantId": "46530365751474",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for dandruff control"
    },
    {
      "variantId": "46528963936434",
      "name": "For Digestion",
      "one_liner": "Digest Boost for Gas and Bloating Relief"
    },
    {
      "variantId": "47302951403698",
      "name": "For Hair Nutrition",
      "one_liner": "Nourish Oil for adding shine to dull hair"
    },
    {
      "variantId": "47301148803250",
      "name": "For Hair texture",
      "one_liner": "Serum for Frizz-free, shiny hair"
    },
    {
      "variantId": "46465792704690",
      "name": "For Hair Nourishment",
      "one_liner": "Iron Santulan for deficiency triggered hair fall"
    },
    {
      "variantId": "47276517195954",
      "name": "For Stress",
      "one_liner": "Calm Ras to improve stress and sleep"
    },
    {
      "variantId": "47276531417266",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "46465512898738",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "44422009323698",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "47300731568306",
      "name": "For Hair Volume",
      "one_liner": "Serum with proven Hair Actives"
    },
    {
      "variantId": "47276511199410",
      "name": "For Digestion",
      "one_liner": "Consti Clear for improved digestion"
    },
    {
      "variantId": "47302757875890",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 01 for hair nourishment"
    },
    {
      "variantId": "47301161091250",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 02 for hair nourishment"
    },
    {
      "variantId": "46464896630962",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 05 for hair nourishment"
    },
    {
      "variantId": "47301139169458",
      "name": "For Stress & Metabolism",
      "one_liner": "Hair Ras 06 for hair nourishment"
    },
    {
      "variantId": "46464745308338",
      "name": "For Stress",
      "one_liner": "Hair Ras 09 for hair nourishment"
    }
  ];

// Function to create the month kit section
function resultMonthKit(response) {
  const productData = response.product_Ids;
  const priceCart = response.cart_price
  
  const containerDiv = document.querySelector('.result-product-kit-wrapper');

  const header = document.createElement('h2');
  header.classList.add('kit-header', 'section-heading-font');
  header.innerText = 'Start your journey with just 1 month kit';
  containerDiv.appendChild(header);

  if(window.innerWidth <= 767){
    containerDiv.classList.remove('container');
  }

  const newSection = document.createElement('section');
  newSection.classList.add('shopify-kit-section');
  
  productData.forEach((each) => {
  const updated = updatedDataFromAPI.find(item => item.variantId === each.product_id);

  const displayName = updated ? updated.name : each.name;
  const displayOneLiner = updated ? updated.one_liner : each.oneLiner;

  const tagsArray = each.tag.tagKeyArray;
  let tagsHTML = '';
  if (tagsArray.length > 1) {
    tagsHTML = tagsArray.map(tag => `<p class="tag-title">${tag}</p>`).join('');
  } else {
    tagsHTML = `<p class="tag-title">${tagsArray[0]}</p>`;
  }

  const productDiv = document.createElement('div');
  productDiv.classList.add('kit-card-container');
  productDiv.dataset.productId = each.product_id;
  productDiv.innerHTML = `
      <div class="kit-card">
          <div class="box-separator-line">
              <div class="product-imge">
                  <img src="${each.image_url.singleImage}" width="80" height="80" />
              </div>
              <div class="product-description">
                  <div class="prod-heading">
                      <p class="prod-title">${displayName}</p>
                  </div>
                  <div>
                      <p class="prod-details">${displayOneLiner}</p>
                  </div>
                  <div>
                      <p class="prod-price">₹ ${Math.floor(each.price)}</p>
                  </div>
              </div>
              <div class="arrow">
                  <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.53255 7.03063L1.53255 12.0306C1.39165 12.1715 1.20056 12.2507 1.0013 12.2507C0.802043 12.2507 0.610947 12.1715 0.470051 12.0306C0.329155 11.8897 0.25 11.6986 0.25 11.4994C0.25 11.3001 0.329155 11.109 0.470051 10.9681L4.93943 6.5L0.471301 2.03063C0.401536 1.96086 0.346196 1.87804 0.308439 1.78689C0.270683 1.69574 0.25125 1.59804 0.25125 1.49938C0.25125 1.40072 0.270683 1.30302 0.308439 1.21187C0.346196 1.12072 0.401536 1.03789 0.471301 0.968128C0.541066 0.898364 0.623889 0.843023 0.715041 0.805267C0.806193 0.76751 0.903889 0.748077 1.00255 0.748077C1.10121 0.748077 1.19891 0.76751 1.29006 0.805267C1.38121 0.843023 1.46404 0.898364 1.5338 0.968128L6.5338 5.96813C6.60364 6.03789 6.65902 6.12075 6.69677 6.21196C6.73451 6.30316 6.75388 6.40093 6.75377 6.49964C6.75365 6.59835 6.73405 6.69606 6.69609 6.78718C6.65813 6.8783 6.60255 6.96103 6.53255 7.03063Z" fill="black"></path>
                  </svg>
              </div>
          </div>
      </div>
  `;
  newSection.appendChild(productDiv);

  // Add to cart logic
  if (getCookie("GuestForm_id")) {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1,
      properties: {
        '_result_id': id
      }
    });
  } else {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1
    });
  }
});

  containerDiv.appendChild(newSection);
  const firstSection = document.querySelectorAll('.hair_thinning_kit-container');
  if (firstSection && firstSection.parentNode) {
    firstSection.parentNode.insertBefore(containerDiv, firstSection.nextSibling);
  }
  addClickEventListernerToMonthkit();
}


// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

function showProductDetails(productId, language) {
  if (!productId) {
    console.error('Product ID is undefined');
    return;
  }
  const tokens = {
    DEV: { 
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: { 
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };

  const nativeLink = {
    devLink: { 
      "siteLink": "public-zxhj2.dev.hav-g.in"
    },
    prodLink: { 
      "siteLink": "public-jgfas325.hav-g.in"
    }
  };

  fetch(`https://${nativeLink.prodLink.siteLink}/productContentv2/${productId}?language=${language}`, {
      headers: tokens.PROD // Using the DEV token as before
  })
  .then((response) => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then((data) => {
      createProductPopup(productId);
  })
  .catch((error) => {
      console.error('Error fetching data:', error);
  });
}

function showKitDetailsDrawer(response){
    if (isMobileDevice()) {
        const popup = document.getElementById('kit-details-drawer');
        const popupContentPlaceholder = popup.querySelector('.kit-details-drawer-placeholder'); 
        const productData = response.product_Ids || [];

        popupContentPlaceholder.innerHTML = '';

        productData.forEach((each) => {
        const updated = updatedDataFromAPI.find(item => item.variantId === each.product_id);
        const displayName = updated ? updated.name : each.name;
        const displayOneLiner = updated ? updated.one_liner : each.oneLiner;

        const productDiv = document.createElement('div');
        productDiv.classList.add('kit-card-container');
        productDiv.dataset.productId = each.product_id;

        productDiv.innerHTML = `
            <div class="kit-card">
            <div class="box-separator-line">
                <div class="product-imge">
                    <img src="${each.image_url.singleImage}" width="80" height="80" />
                </div>
                <div class="product-description">
                    <div class="prod-heading">
                        <p class="prod-title">${displayName}</p>
                    </div>
                    <div>
                        <p class="prod-details">${displayOneLiner}</p>
                    </div>
                    <div>
                        <p class="prod-price">₹ ${Math.floor(each.price)}</p>
                    </div>
                </div>
            </div>
            </div>
        `;
        popupContentPlaceholder.appendChild(productDiv);
        });

        const kitDetailsClicker = document.querySelector('.result-detail-kit--image-container.result-kit-details');
        const kitDrawer = document.getElementById('kit-details-drawer');
        const closeDrawer = kitDrawer.querySelector('#close-kit-drawer');
        const overlay = document.getElementById('background-overlay');

        // click to open
        kitDetailsClicker.addEventListener('click', () => {
        kitDrawer.classList.add('active');
        overlay.style.display = 'block';
        document.body.style.overflow = 'hidden';
        });

        // click to close
        closeDrawer.addEventListener('click', () => {
        kitDrawer.classList.remove('active');
        overlay.style.display = 'none';
        document.body.style.overflow = 'auto';
        });

        // also close if overlay is clicked
        overlay.addEventListener('click', () => {
        kitDrawer.classList.remove('active');
        overlay.style.display = 'none';
        document.body.style.overflow = 'auto';
        });
    }
}

// Function to add click event listener to month kit product cards
function addClickEventListernerToMonthkit() {
  document.querySelectorAll('.shopify-kit-section .kit-card-container').forEach((kit) => {
    kit.addEventListener('click', function (event) {
      const productId = event.currentTarget.getAttribute('data-product-id');
      const language = 'english'; // Assuming 'english' is the desired language
      showProductDetails(productId, language);
    });
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = 'auto';
}

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };

  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  
  // Load external product detail page into popup content placeholder
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    // Mobile view: popup from the bottom
    popup.style.bottom = '0';
  } else {
    // Desktop view: popup from the right
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Close popup when close icon is clicked
  const closeIcon = document.querySelector('#product-popup #close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });

  // Close popup when overlay is clicked
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    const weeksUpdateElement = document.querySelectorAll('.weeks-update')
    weeksUpdateElement.forEach((weeksElement)=>{
      weeksElement.innerHTML = monthsExpectation.months;
    })
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}" width="100" height="100">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p>${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });
    if(window.innerWidth > 767){
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "15px",
            },
          },
        ],
      });
    }
  }
}

// Checking Eligibility
function checkEligibility() {
  // Hide the checking container and show the loading container
  document.querySelector('.checking-container').style.display = 'none';
  document.querySelector('.loading-container').style.display = 'flex';
  
  // Simulate an API call with setTimeout
  setTimeout(() => {
    // Hide the loading container and show the eligibility result container
    document.querySelector('.loading-container').style.display = 'none';
    document.querySelector('.eligibilty-result').style.display = 'block';
  }, 1000); // Change the duration as needed
}

// functionality for real stories
function sectionRealStories(response) {
  let { successStories } = response;
  if (successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');
    const subTitleElement = document.querySelector('.stories-sub-heading');

    // Set title and subtitle
    titleElement.textContent = 'Real Men, Real Stories';
    subTitleElement.textContent = successStories.subTitle;

    // Loop through each story to create image elements
    successStories.stories.forEach((storyUrl) => {
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl.imageUrl}" alt="Success Story" height="auto" width="auto">
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    // Initialize the Slick carousel after appending elements
    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true, 
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px"
          },
        },
      ],
    });
  }
}